import { serverURL } from "@/utils/serverURL";

export type CompositionRow = {
  compound: string;
  ratio: number;
};

export type CompositionResponse =
  | { hasTargetFood: false; food: null; rows: CompositionRow[] }
  | {
      hasTargetFood: true;
      food: { id: number; name: string };
      nfoodVersionId: number;
      rows: CompositionRow[];
    };

export async function fetchFlavorComposition(
  flavorId: string,
  signal?: AbortSignal,
): Promise<CompositionResponse> {
  const res = await fetch(serverURL`/me/flavor/${flavorId}/composition`, {
    credentials: "include",
    signal,
  });
  if (!res.ok) {
    throw new Error(`flavor/${flavorId}/composition failed: ${res.status}`);
  }
  return (await res.json()) as CompositionResponse;
}
